import { PartState } from '../types';

export const curiousState: PartState = {
	antenna1: {
		path: 'M171.5 68C174 59.1667 183.6 41.4 202 41',
		tip: { cx: 203, cy: 41, r: 4.5 },
	},
	antenna2: {
		path: 'M129 68C131.5 59.1667 141.1 41.4 159.5 41',
		tip: { cx: 159, cy: 41, r: 4.5 },
	},
	body: { x: 103, y: 62, width: 100, height: 162, rx: 32 },
	bodyHighlight:
		'M184 79C172.649 65.0899 142.137 61.3331 132 61C211.534 61 207.635 61 213.873 138.954C218.531 197.168 196.756 220.66 188.13 222.445C187.194 222.638 186.495 221.842 186.495 220.886C186.504 178.976 196.493 94.3093 184 79Z',
	stripes: { y1: 140, y2: 169, y3: 198, height: 15 },
	eyes: { y: 96.5, leftX: 113.435, rightX: 151.966, width: 10.4139, height: 16.6623, rx: 5.20697 },
	wing1Path:
		'M200.476 80.9972L174.921 118.52C173.405 120.745 172.559 123.358 172.482 126.049C172.261 133.826 178.386 140.31 186.163 140.532L188.721 140.605C191.15 140.674 193.565 140.21 195.796 139.247L228.755 125.011C230.896 124.086 232.921 122.914 234.79 121.518L240.444 117.295C248.081 111.592 252.144 102.284 251.133 92.8064C249.493 77.4305 235.296 66.5728 220.027 69.0171L219.108 69.1641C211.534 70.3766 204.794 74.6571 200.476 80.9972Z',
	wing2Path:
		'M220.524 107.366L182.505 132.178C180.251 133.649 178.465 135.736 177.36 138.191C174.165 145.285 177.326 153.626 184.42 156.82L186.753 157.871C188.969 158.869 191.376 159.37 193.806 159.338L229.705 158.87C232.037 158.839 234.358 158.536 236.619 157.966L243.463 156.242C252.705 153.914 260.035 146.883 262.746 137.746C267.144 122.921 258.213 107.439 243.178 103.825L242.274 103.607C234.815 101.814 226.948 103.174 220.524 107.366Z',
	arms: [{ d: 'M196.227 142.747L220.758 161.884', side: 'right' }],
	stinger:
		'M196.056 243.417C194.016 240.528 192.39 235.774 191.25 231.283C190.335 227.683 186.379 225.597 183.023 227.189C180.249 228.505 179.06 231.865 181.064 234.192C184.991 238.752 190.738 242.155 195.38 244.252C196.385 244.706 196.692 244.318 196.056 243.417Z',
};
